// Actual Peakstone product data for Timberlake Flooring
// Product names and SKUs from Peakstone catalog

export const products = [
  // ComfortSense Collection - Water-Resistant Laminate (10 products)
  {
    id: 1,
    name: "Canyon",
    sku: "PCS784805CA",
    collection: "ComfortSense",
    type: "laminate",
    category: "Water-Resistant Laminate",
    image: "https://peakstonefloor.ca/images/products/Canyon%202.jpg",
    thickness: "12mm",
    width: "7.5\"",
    length: "48\"",
    warranty: "25 years",
    features: ["Water-resistant", "AC4 rated", "Easy click installation"],
    price: "Contact for pricing"
  },
  {
    id: 2,
    name: "Cliff",
    sku: "PCS784803CF",
    collection: "ComfortSense",
    type: "laminate",
    category: "Water-Resistant Laminate",
    image: "https://peakstonefloor.ca/images/products/Cliff%202.jpg",
    thickness: "12mm",
    width: "7.5\"",
    length: "48\"",
    warranty: "25 years",
    features: ["Water-resistant", "Scratch-resistant", "Pet-friendly"],
    price: "Contact for pricing"
  },
  {
    id: 3,
    name: "Desert",
    sku: "PCS784804DE",
    collection: "ComfortSense",
    type: "laminate",
    category: "Water-Resistant Laminate",
    image: "https://peakstonefloor.ca/images/products/Desert%202.jpg",
    thickness: "12mm",
    width: "7.5\"",
    length: "48\"",
    warranty: "25 years",
    features: ["Water-resistant", "High durability", "Anti-slip surface"],
    price: "Contact for pricing"
  },
  {
    id: 4,
    name: "Glacier",
    sku: "PCS784801GL",
    collection: "ComfortSense",
    type: "laminate",
    category: "Water-Resistant Laminate",
    image: "https://peakstonefloor.ca/images/products/Glacier%202.jpg",
    thickness: "12mm",
    width: "7.5\"",
    length: "48\"",
    warranty: "25 years",
    features: ["Water-resistant", "AC4 rated", "Easy maintenance"],
    price: "Contact for pricing"
  },
  {
    id: 5,
    name: "Gulf",
    sku: "PCS784806GU",
    collection: "ComfortSense",
    type: "laminate",
    category: "Water-Resistant Laminate",
    image: "https://peakstonefloor.ca/images/products/Gulf%202.jpg",
    thickness: "12mm",
    width: "7.5\"",
    length: "48\"",
    warranty: "25 years",
    features: ["Water-resistant", "Commercial grade", "Durable finish"],
    price: "Contact for pricing"
  },
  {
    id: 6,
    name: "Meadow",
    sku: "PCS784802ME",
    collection: "ComfortSense",
    type: "laminate",
    category: "Water-Resistant Laminate",
    image: "https://peakstonefloor.ca/images/products/Meadow%202.jpg",
    thickness: "12mm",
    width: "7.5\"",
    length: "48\"",
    warranty: "25 years",
    features: ["Water-resistant", "Natural texture", "Easy installation"],
    price: "Contact for pricing"
  },
  {
    id: 7,
    name: "Oasis",
    sku: "PCS784807AS",
    collection: "ComfortSense",
    type: "laminate",
    category: "Water-Resistant Laminate",
    image: "https://peakstonefloor.ca/images/products/Oasis%202.jpg",
    thickness: "12mm",
    width: "7.5\"",
    length: "48\"",
    warranty: "25 years",
    features: ["Water-resistant", "Embossed surface", "Scratch-resistant"],
    price: "Contact for pricing"
  },
  {
    id: 8,
    name: "Reef",
    sku: "PCS784810RE",
    collection: "ComfortSense",
    type: "laminate",
    category: "Water-Resistant Laminate",
    image: "https://peakstonefloor.ca/images/products/Reef%202.jpg",
    thickness: "12mm",
    width: "7.5\"",
    length: "48\"",
    warranty: "25 years",
    features: ["Water-resistant", "Realistic wood look", "High performance"],
    price: "Contact for pricing"
  },
  {
    id: 9,
    name: "Summit",
    sku: "PCS784808SU",
    collection: "ComfortSense",
    type: "laminate",
    category: "Water-Resistant Laminate",
    image: "https://peakstonefloor.ca/images/products/Summit%202.jpg",
    thickness: "12mm",
    width: "7.5\"",
    length: "48\"",
    warranty: "25 years",
    features: ["Water-resistant", "Premium quality", "Easy to clean"],
    price: "Contact for pricing"
  },
  {
    id: 10,
    name: "Waterfall",
    sku: "PCS784809WF",
    collection: "ComfortSense",
    type: "laminate",
    category: "Water-Resistant Laminate",
    image: "https://peakstonefloor.ca/images/products/Waterfall%202.jpg",
    thickness: "12mm",
    width: "7.5\"",
    length: "48\"",
    warranty: "25 years",
    features: ["Water-resistant", "Contemporary style", "Durable core"],
    price: "Contact for pricing"
  },

  // SolidSense Collection - Rigid-Core Vinyl (SPC) (8 products)
  {
    id: 11,
    name: "Dawn",
    sku: "PSS726508DA",
    collection: "SolidSense",
    type: "vinyl",
    category: "Rigid-Core Vinyl (SPC)",
    image: "https://peakstonefloor.ca/images/products/20250712112845209504_2613.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    warranty: "Lifetime residential",
    features: ["100% waterproof", "Commercial grade", "Sound absorption"],
    price: "Contact for pricing"
  },
  {
    id: 12,
    name: "Gloam",
    sku: "PSS726503GL",
    collection: "SolidSense",
    type: "vinyl",
    category: "Rigid-Core Vinyl (SPC)",
    image: "https://peakstonefloor.ca/images/products/20250712112916922774_1211.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    warranty: "Lifetime residential",
    features: ["Waterproof", "Stain-resistant", "Easy maintenance"],
    price: "Contact for pricing"
  },
  {
    id: 13,
    name: "Golden Hour",
    sku: "PSS726506GH",
    collection: "SolidSense",
    type: "vinyl",
    category: "Rigid-Core Vinyl (SPC)",
    image: "https://peakstonefloor.ca/images/products/20250712112941229366_3362.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    warranty: "Lifetime residential",
    features: ["Waterproof", "Scratch-resistant", "UV protection"],
    price: "Contact for pricing"
  },
  {
    id: 14,
    name: "Moonlight",
    sku: "PSS726504ML",
    collection: "SolidSense",
    type: "vinyl",
    category: "Rigid-Core Vinyl (SPC)",
    image: "https://peakstonefloor.ca/images/products/20250712113000626995_2776.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    warranty: "Lifetime residential",
    features: ["Waterproof", "Rigid core", "Comfortable underfoot"],
    price: "Contact for pricing"
  },
  {
    id: 15,
    name: "Serenity",
    sku: "PSS726505SE",
    collection: "SolidSense",
    type: "vinyl",
    category: "Rigid-Core Vinyl (SPC)",
    image: "https://peakstonefloor.ca/images/products/20250712113019936700_7918.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    warranty: "Lifetime residential",
    features: ["Waterproof", "Impact resistant", "Easy installation"],
    price: "Contact for pricing"
  },
  {
    id: 16,
    name: "Silverlining",
    sku: "PSS726501SL",
    collection: "SolidSense",
    type: "vinyl",
    category: "Rigid-Core Vinyl (SPC)",
    image: "https://peakstonefloor.ca/images/products/20250712113038364649_5568.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    warranty: "Lifetime residential",
    features: ["Waterproof", "Modern design", "Low maintenance"],
    price: "Contact for pricing"
  },
  {
    id: 17,
    name: "Sunrise",
    sku: "PSS726502SR",
    collection: "SolidSense",
    type: "vinyl",
    category: "Rigid-Core Vinyl (SPC)",
    image: "https://peakstonefloor.ca/images/products/20250712113055469450_7400.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    warranty: "Lifetime residential",
    features: ["Waterproof", "Warm tones", "Durable surface"],
    price: "Contact for pricing"
  },
  {
    id: 18,
    name: "Twilight",
    sku: "PSS726507TL",
    collection: "SolidSense",
    type: "vinyl",
    category: "Rigid-Core Vinyl (SPC)",
    image: "https://peakstonefloor.ca/images/products/20250712113111435846_9075.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    warranty: "Lifetime residential",
    features: ["Waterproof", "Contemporary look", "Sound dampening"],
    price: "Contact for pricing"
  },

  // NatureSense Collection - Engineered Hardwood (8 products)
  {
    id: 19,
    name: "Piccadilly Prime",
    sku: "LWA760302PI",
    collection: "NatureSense",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://peakstonefloor.ca/images/products/Piccadilly%20Prime%202.jpg",
    thickness: "5/8\"",
    width: "5\"",
    length: "Random up to 84\"",
    warranty: "50 years",
    features: ["Real hardwood", "Multi-layer construction", "Handscraped finish"],
    price: "Contact for pricing"
  },
  {
    id: 20,
    name: "Piccadilly",
    sku: "LWC760301PI",
    collection: "NatureSense",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://peakstonefloor.ca/images/products/Piccadilly%202.jpg",
    thickness: "5/8\"",
    width: "5\"",
    length: "Random up to 84\"",
    warranty: "50 years",
    features: ["Premium hardwood", "Wire-brushed texture", "Stain-resistant"],
    price: "Contact for pricing"
  },
  {
    id: 21,
    name: "Wood Green",
    sku: "LWC760303WG",
    collection: "NatureSense",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://peakstonefloor.ca/images/products/Wood%20Green%202.jpg",
    thickness: "5/8\"",
    width: "5\"",
    length: "Random up to 84\"",
    warranty: "50 years",
    features: ["Authentic wood grain", "Stable construction", "Pre-finished"],
    price: "Contact for pricing"
  },
  {
    id: 22,
    name: "Southgate",
    sku: "LWC760304SO",
    collection: "NatureSense",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://peakstonefloor.ca/images/products/Southgate%202.jpg",
    thickness: "5/8\"",
    width: "5\"",
    length: "Random up to 84\"",
    warranty: "50 years",
    features: ["Natural beauty", "Engineered stability", "Long-lasting"],
    price: "Contact for pricing"
  },
  {
    id: 23,
    name: "Trafalgar",
    sku: "LWC760305TR",
    collection: "NatureSense",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://peakstonefloor.ca/images/products/Trafalgar%202.jpg",
    thickness: "5/8\"",
    width: "5\"",
    length: "Random up to 84\"",
    warranty: "50 years",
    features: ["Rich color", "Hardwood surface", "Premium quality"],
    price: "Contact for pricing"
  },
  {
    id: 24,
    name: "Euston",
    sku: "LWC760306EU",
    collection: "NatureSense",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://peakstonefloor.ca/images/products/Euston%202.jpg",
    thickness: "5/8\"",
    width: "5\"",
    length: "Random up to 84\"",
    warranty: "50 years",
    features: ["Elegant finish", "Durable construction", "Timeless appeal"],
    price: "Contact for pricing"
  },
  {
    id: 25,
    name: "Covent Garden",
    sku: "LWC760307CG",
    collection: "NatureSense",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://peakstonefloor.ca/images/products/Covernt%20Garden%202.jpg",
    thickness: "5/8\"",
    width: "5\"",
    length: "Random up to 84\"",
    warranty: "50 years",
    features: ["Classic style", "Engineered core", "Refinishable surface"],
    price: "Contact for pricing"
  },
  {
    id: 26,
    name: "Camden",
    sku: "LWC760308CA",
    collection: "NatureSense",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://peakstonefloor.ca/images/products/Camden%202.jpg",
    thickness: "5/8\"",
    width: "5\"",
    length: "Random up to 84\"",
    warranty: "50 years",
    features: ["Sophisticated look", "Natural hardwood", "High-end finish"],
    price: "Contact for pricing"
  },

  // Accessories - Underlayments
  {
    id: 27,
    name: "Premium Underlayment 2mm",
    sku: "ACC-UND-2MM",
    collection: "Accessories",
    type: "underlay",
    category: "Underlayments",
    image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=400&h=300&fit=crop",
    thickness: "2mm",
    width: "4'",
    length: "100'",
    warranty: "N/A",
    features: ["Sound dampening", "Moisture barrier", "Easy installation"],
    price: "Contact for pricing"
  },
  {
    id: 28,
    name: "Premium Underlayment 3mm",
    sku: "ACC-UND-3MM",
    collection: "Accessories",
    type: "underlay",
    category: "Underlayments",
    image: "https://images.unsplash.com/photo-1598718544285-7180f670198b?w=400&h=300&fit=crop",
    thickness: "3mm",
    width: "4'",
    length: "100'",
    warranty: "N/A",
    features: ["Superior sound reduction", "Moisture protection", "Thermal insulation"],
    price: "Contact for pricing"
  },
  {
    id: 29,
    name: "Vapor Barrier Underlayment",
    sku: "ACC-UND-VB",
    collection: "Accessories",
    type: "underlay",
    category: "Underlayments",
    image: "https://images.pexels.com/photos/326862/pexels-photo-326862.jpeg?w=400&h=300&fit=crop",
    thickness: "2mm",
    width: "4'",
    length: "100'",
    warranty: "N/A",
    features: ["Moisture barrier", "Mold resistant", "Basement approved"],
    price: "Contact for pricing"
  },

  // Accessories - Flush Stair Nosings
  {
    id: 30,
    name: "Flush Stair Nosing - Natural Oak",
    sku: "ACC-SN-OAK",
    collection: "Accessories",
    type: "stair_nosings",
    category: "Flush Stair Nosings",
    image: "https://images.unsplash.com/photo-1626551039948-ddd7e595fe06?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2.75\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Matching finish", "Easy installation", "Durable hardwood"],
    price: "Contact for pricing"
  },
  {
    id: 31,
    name: "Flush Stair Nosing - Dark Walnut",
    sku: "ACC-SN-WAL",
    collection: "Accessories",
    type: "stair_nosings",
    category: "Flush Stair Nosings",
    image: "https://images.unsplash.com/photo-1575204015311-0fe377370780?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2.75\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Rich color", "Pre-finished", "Easy to install"],
    price: "Contact for pricing"
  },
  {
    id: 32,
    name: "Flush Stair Nosing - Maple",
    sku: "ACC-SN-MAP",
    collection: "Accessories",
    type: "stair_nosings",
    category: "Flush Stair Nosings",
    image: "https://images.unsplash.com/photo-1686056040167-1e3dead46d9a?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2.75\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Light tone", "Smooth finish", "Stair safe"],
    price: "Contact for pricing"
  },
  {
    id: 33,
    name: "Flush Stair Nosing - Gray",
    sku: "ACC-SN-GRY",
    collection: "Accessories",
    type: "stair_nosings",
    category: "Flush Stair Nosings",
    image: "https://images.unsplash.com/photo-1560185008-b033106af5c3?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2.75\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Modern color", "Universal compatible", "Non-slip"],
    price: "Contact for pricing"
  },

  // Accessories - T-Mouldings
  {
    id: 34,
    name: "T-Moulding - Natural Oak",
    sku: "ACC-TM-OAK",
    collection: "Accessories",
    type: "t-mouldings",
    category: "T-Mouldings",
    image: "https://images.unsplash.com/photo-1575204015311-0fe377370780?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Versatile", "Multiple finishes", "Professional look"],
    price: "Contact for pricing"
  },
  {
    id: 35,
    name: "T-Moulding - Dark Walnut",
    sku: "ACC-TM-WAL",
    collection: "Accessories",
    type: "t-mouldings",
    category: "T-Mouldings",
    image: "https://images.unsplash.com/photo-1626551039948-ddd7e595fe06?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Transition piece", "Room to room", "Easy install"],
    price: "Contact for pricing"
  },
  {
    id: 36,
    name: "T-Moulding - Gray",
    sku: "ACC-TM-GRY",
    collection: "Accessories",
    type: "t-mouldings",
    category: "T-Mouldings",
    image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Modern style", "Universal match", "Flexible"],
    price: "Contact for pricing"
  },
  {
    id: 37,
    name: "T-Moulding - Universal",
    sku: "ACC-TM-UNI",
    collection: "Accessories",
    type: "t-mouldings",
    category: "T-Mouldings",
    image: "https://images.pexels.com/photos/326862/pexels-photo-326862.jpeg?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Fits all floors", "Neutral color", "Standard size"],
    price: "Contact for pricing"
  },

  // Accessories - Reducers
  {
    id: 38,
    name: "Reducer - Natural Oak",
    sku: "ACC-RED-OAK",
    collection: "Accessories",
    type: "reducers",
    category: "Reducers",
    image: "https://images.unsplash.com/photo-1686056040167-1e3dead46d9a?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Height transition", "Smooth edge", "Easy installation"],
    price: "Contact for pricing"
  },
  {
    id: 39,
    name: "Reducer - Dark Walnut",
    sku: "ACC-RED-WAL",
    collection: "Accessories",
    type: "reducers",
    category: "Reducers",
    image: "https://images.unsplash.com/photo-1560185008-b033106af5c3?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Floor to carpet", "Professional finish", "Pre-finished"],
    price: "Contact for pricing"
  },
  {
    id: 40,
    name: "Reducer - Gray",
    sku: "ACC-RED-GRY",
    collection: "Accessories",
    type: "reducers",
    category: "Reducers",
    image: "https://images.unsplash.com/photo-1598718544285-7180f670198b?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Modern design", "Threshold piece", "Durable"],
    price: "Contact for pricing"
  },
  {
    id: 41,
    name: "Reducer - Universal",
    sku: "ACC-RED-UNI",
    collection: "Accessories",
    type: "reducers",
    category: "Reducers",
    image: "https://images.pexels.com/photos/3623785/pexels-photo-3623785.jpeg?w=400&h=300&fit=crop",
    thickness: "3/4\"",
    width: "2\"",
    length: "94\"",
    warranty: "N/A",
    features: ["Neutral tone", "Standard profile", "Easy to cut"],
    price: "Contact for pricing"
  },

  // Accessories
  {
    id: 42,
    name: "Premium Underlayment",
    sku: "ACC-UND-001",
    collection: "Accessories",
    type: "accessory",
    category: "Underlayments",
    image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800",
    features: ["Sound reduction", "Moisture barrier", "Easy installation"],
    price: "Contact for pricing"
  },

  // Onn:Guard Collection - Waterproof Laminate (4 products)
  {
    id: 43,
    name: "Shield",
    sku: "ONN5844",
    collection: "Guard",
    type: "laminate",
    category: "Waterproof Laminate",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/guard-onn5844-shield-swatch7518.jpg",
    thickness: "10mm",
    width: "7-5/8\"",
    length: "47-3/4\"",
    warranty: "Lifetime Residential",
    features: ["100% Waterproof", "AC4 Durability", "Pet Friendly", "Pre-attached EVA Underpad", "Unilin Click Lock"],
    description: "Shield offers robust protection with a stunning natural wood appearance. Engineered to withstand daily wear while maintaining its beautiful aesthetic.",
    price: "Contact for pricing"
  },
  {
    id: 44,
    name: "Fortify",
    sku: "ONN5845",
    collection: "Guard",
    type: "laminate",
    category: "Waterproof Laminate",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/guard-onn5845-fortify-swatch1548.jpg",
    thickness: "10mm",
    width: "7-5/8\"",
    length: "47-3/4\"",
    warranty: "Lifetime Residential",
    features: ["100% Waterproof", "AC4 Durability", "Pet Friendly", "EIR Texture", "Soft Quiet Step"],
    description: "Fortify combines strength and style with embossed-in-register texture that delivers authentic wood grain character and exceptional durability.",
    price: "Contact for pricing"
  },
  {
    id: 45,
    name: "Vigilant",
    sku: "ONN5846",
    collection: "Guard",
    type: "laminate",
    category: "Waterproof Laminate",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/guard-onn5846-vigilant-swatchc24f.jpg",
    thickness: "10mm",
    width: "7-5/8\"",
    length: "47-3/4\"",
    warranty: "Lifetime Residential",
    features: ["100% Waterproof", "AC4 Durability", "Scratch Resistant", "Micro Bevel Edge", "Fast Installation"],
    description: "Vigilant stands guard against moisture and wear with its premium waterproof construction and sophisticated wood-look finish.",
    price: "Contact for pricing"
  },
  {
    id: 46,
    name: "Armor",
    sku: "ONN5847",
    collection: "Guard",
    type: "laminate",
    category: "Waterproof Laminate",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/guard-onn5847-armor-swatche20d.jpg",
    thickness: "10mm",
    width: "7-5/8\"",
    length: "47-3/4\"",
    warranty: "Lifetime Residential",
    features: ["100% Waterproof", "AC4 Commercial Grade", "Fade Resistant", "2mm EVA Underpad", "Lifetime Warranty"],
    description: "Armor provides ultimate protection with top-tier durability and a rich, natural appearance perfect for high-traffic areas.",
    price: "Contact for pricing"
  },

  // Onn:Peak Collection - Extra Large Premium Flooring (9 products)
  {
    id: 47,
    name: "Summit",
    sku: "ONN5857",
    collection: "Peak",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/peak-onn5857-summit-swatch91b0.jpg",
    thickness: "12mm",
    width: "7-1/8\"",
    length: "72\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["100% Waterproof", "20mil Wear Layer", "Extra Large Format", "1mm IXPE Foam Pad", "Painted Bevel Edge"],
    description: "Summit reaches the peak of luxury vinyl design with extra-large and superior 20mil wear layer for unmatched elegance and durability.",
    price: "Contact for pricing"
  },
  {
    id: 48,
    name: "Quest",
    sku: "ONN5858",
    collection: "Peak",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/peak-onn5858-quest-swatcha582.jpg",
    thickness: "12mm",
    width: "7-1/8\"",
    length: "72\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Rigid Core Construction", "Pet & Child Friendly", "Embossed in Register", "Hydronic Heat Compatible", "Easy Click Lock"],
    description: "Quest delivers a journey of sophistication with its striking wood grain patterns and commercial-grade performance in extra-large format.",
    price: "Contact for pricing"
  },
  {
    id: 49,
    name: "Crestline",
    sku: "ONN5859",
    collection: "Peak",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/peak-onn5859-crestline-swatch3813.jpg",
    thickness: "12mm",
    width: "7-1/8\"",
    length: "72\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Premium Rigid Core", "Scratch & Dent Resistant", "Low Gloss Finish", "Sound Reduction", "Fast Installation"],
    description: "Crestline sits at the top with refined aesthetics and robust construction, perfect for creating stunning, long-lasting floors.",
    price: "Contact for pricing"
  },
  {
    id: 50,
    name: "Acme",
    sku: "ONN5860",
    collection: "Peak",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/peak-onn5860-acme-swatch82e7.jpg",
    thickness: "12mm",
    width: "7-1/8\"",
    length: "72\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Premium 20mil Wear Layer", "Waterproof Core", "Authentic Wood Texture", "Color Fade Resistant", "1 in 5 Pattern Repeat"],
    description: "Acme represents the pinnacle of vinyl flooring technology with exceptional wear resistance and timeless design.",
    price: "Contact for pricing"
  },
  {
    id: 51,
    name: "Pinnacle",
    sku: "ONN5861",
    collection: "Peak",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/peak-onn5861-pinnacle-swatchf10a.jpg",
    thickness: "12mm",
    width: "7-1/8\"",
    length: "72\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Extra Thick 12mm", "Enhanced Sound Reduction", "Pre-attached Foam Pad", "Above/On/Below Grade", "Unilin Click System"],
    description: "Pinnacle achieves the highest standard in luxury vinyl with superior thickness and acoustic performance in a stunning wood aesthetic.",
    price: "Contact for pricing"
  },
  {
    id: 52,
    name: "Ridgeline",
    sku: "ONN5862",
    collection: "Peak",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/peak-onn5862-ridgeline-swatchc990.jpg",
    thickness: "12mm",
    width: "7-1/8\"",
    length: "72\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Rigid Core Stability", "Enhanced Texture Detail", "Moisture Proof", "Heavy Traffic Rated", "Lifetime Warranty"],
    description: "Ridgeline offers dramatic wood grain character with exceptional dimensional stability and commercial-grade durability.",
    price: "Contact for pricing"
  },
  {
    id: 53,
    name: "Snowtop",
    sku: "ONN5863",
    collection: "Peak",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/peak-onn5863-snowtop-swatch7b1f.jpg",
    thickness: "12mm",
    width: "7-1/8\"",
    length: "72\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Light Elegant Tone", "20mil Heavy Duty Wear Layer", "Waterproof Construction", "Easy Maintenance", "Painted Bevel"],
    description: "Snowtop brings fresh, bright elegance with its light wood tones and premium construction for spaces seeking airy sophistication.",
    price: "Contact for pricing"
  },
  {
    id: 54,
    name: "Pioneer",
    sku: "ONN5864",
    collection: "Peak",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/peak-onn5864-pioneer-swatch67ac.jpg",
    thickness: "12mm",
    width: "7-1/8\"",
    length: "72\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Rustic Character", "Extra Large Format", "Pet Proof", "Scratch Resistant", "6 ft Long Boards"],
    description: "Pioneer leads the way with bold, rustic charm in extra-large that make a dramatic statement in any space.",
    price: "Contact for pricing"
  },
  {
    id: 55,
    name: "Zenith",
    sku: "ONN5865",
    collection: "Peak",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/peak-onn5865-zenith-swatch3d00.jpg",
    thickness: "12mm",
    width: "7-1/8\"",
    length: "72\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Premium 20mil Protection", "Rich Wood Tones", "Rigid Core Technology", "Sound Dampening", "Fast Click Installation"],
    description: "Zenith reaches the highest point of luxury vinyl excellence with rich, deep tones and uncompromising performance.",
    price: "Contact for pricing"
  },

  // Onn:Point Collection - Premium Flooring (7 products)
  {
    id: 56,
    name: "Precision",
    sku: "ONN5501",
    collection: "Point",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/point-onn5501-precision-swatch3965.jpg",
    thickness: "5mm",
    width: "7\"",
    length: "60\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 10 Years Commercial",
    features: ["SPC Core", "20mil Wear Layer", "Waterproof", "1mm IPXE Foam Underpad", "Painted Bevel"],
    description: "Precision embodies meticulous craftsmanship with exacting standards and a flawless finish that elevates any interior design.",
    price: "Contact for pricing"
  },
  {
    id: 57,
    name: "Sophisticated",
    sku: "ONN5502",
    collection: "Point",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/point-onn5502-sophisticated-swatch79cd.jpg",
    thickness: "5mm",
    width: "7\"",
    length: "60\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 10 Years Commercial",
    features: ["Stone Plastic Composite", "Enhanced Texture", "63 dB STC Rating", "Pet Friendly", "Unilin Click Lock"],
    description: "Sophisticated delivers refined elegance with premium sound dampening and authentic wood grain texture for discerning spaces.",
    price: "Contact for pricing"
  },
  {
    id: 58,
    name: "Refined",
    sku: "ONN5503",
    collection: "Point",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/point-onn5503-refined-swatchc4d9.jpg",
    thickness: "5mm",
    width: "7\"",
    length: "60\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 10 Years Commercial",
    features: ["Durable SPC Core", "Waterproof Design", "Low Gloss Finish", "Scratch Resistant", "Easy Clean"],
    description: "Refined showcases understated luxury with subtle wood tones and superior wear resistance perfect for modern living.",
    price: "Contact for pricing"
  },
  {
    id: 59,
    name: "Flawless",
    sku: "ONN5504",
    collection: "Point",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/point-onn5504-flawless-swatch83de.jpg",
    thickness: "5mm",
    width: "7\"",
    length: "60\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 10 Years Commercial",
    features: ["Perfect Alignment System", "20mil Heavy Traffic Layer", "Waterproof Core", "Above/Below Grade", "1 in 5 Pattern"],
    description: "Flawless ensures impeccable installation with precision engineering and timeless aesthetics that never go out of style.",
    price: "Contact for pricing"
  },
  {
    id: 60,
    name: "Polished",
    sku: "ONN5506",
    collection: "Point",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/point-onn5506-polished-swatch15de.jpg",
    thickness: "5mm",
    width: "7\"",
    length: "60\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 10 Years Commercial",
    features: ["Smooth Surface", "Enhanced Durability", "Moisture Proof", "Fade Resistant", "Fast Installation"],
    description: "Polished brings refined sophistication with a smooth, elegant finish that adds instant class to residential and commercial spaces.",
    price: "Contact for pricing"
  },
  {
    id: 61,
    name: "Pristine",
    sku: "ONN5505",
    collection: "Point",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/point-onn5505-pristine-swatch3dea.jpg",
    thickness: "5mm",
    width: "7\"",
    length: "60\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 10 Years Commercial",
    features: ["Clean Contemporary Look", "SPC Construction", "Waterproof Performance", "Sound Reduction", "Pet Proof"],
    description: "Pristine maintains immaculate beauty with its clean lines and superior stain resistance, perfect for family-friendly homes.",
    price: "Contact for pricing"
  },
  {
    id: 62,
    name: "Elegant",
    sku: "ONN5507",
    collection: "Point",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/point-onn5507-elegant-swatche14f.jpg",
    thickness: "5mm",
    width: "7\"",
    length: "60\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 10 Years Commercial",
    features: ["Timeless Design", "20mil Commercial Grade", "Waterproof SPC", "Hydronic Heat Compatible", "Lifetime Warranty"],
    description: "Elegant combines classic beauty with modern performance, delivering refined style that enhances any architectural aesthetic.",
    price: "Contact for pricing"
  },

  // Onn:Beat Collection - Engineered Hardwood (6 products)
  {
    id: 63,
    name: "Rhythm",
    sku: "ONN5840",
    collection: "Beat",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/beat-onn5840-rhythm-swatch2a70.jpg",
    thickness: "1/2\"",
    width: "5\"",
    length: "Random Length",
    warranty: "Limited Lifetime",
    features: ["Premium White Oak", "UV Oil Finish", "Tongue & Groove", "Natural Variations", "Handscraped Texture"],
    description: "Rhythm sets the beat with dynamic premium oak character and handcrafted texture that brings authentic wood beauty to life.",
    price: "Contact for pricing"
  },
  {
    id: 64,
    name: "Tempo",
    sku: "ONN5852",
    collection: "Beat",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/beat-onn5852-tempo-swatchb54c.jpg",
    thickness: "1/2\"",
    width: "5\"",
    length: "Random Length",
    warranty: "Limited Lifetime",
    features: ["Wire Brushed Finish", "Rich Wood Tones", "Engineered Stability", "Easy Installation", "Natural Character"],
    description: "Tempo delivers steady, timeless elegance with wire-brushed texture and rich tones that create warmth in any room.",
    price: "Contact for pricing"
  },
  {
    id: 65,
    name: "Harmony",
    sku: "ONN5883",
    collection: "Beat",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/beat-onn5883-harmony-swatch0e5f.jpg",
    thickness: "1/2\"",
    width: "5\"",
    length: "Random Length",
    warranty: "Limited Lifetime",
    features: ["Balanced Color Palette", "Smooth Surface", "Premium Oak", "Low Maintenance", "Durable Finish"],
    description: "Harmony blends perfectly with any decor, offering balanced tones and smooth texture for effortless sophistication.",
    price: "Contact for pricing"
  },
  {
    id: 66,
    name: "Melody",
    sku: "ONN5890",
    collection: "Beat",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/beat-onn5890-melody-swatch432f.jpg",
    thickness: "1/2\"",
    width: "5\"",
    length: "Random Length",
    warranty: "Limited Lifetime",
    features: ["Light Natural Tones", "Wire Brushed", "Engineered Construction", "Dimensional Stability", "Easy Care"],
    description: "Melody sings with light, airy tones and natural texture that brightens spaces with organic premium oak beauty.",
    price: "Contact for pricing"
  },
  {
    id: 67,
    name: "Pulse",
    sku: "ONN5894",
    collection: "Beat",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/beat-onn5894-pulse-swatchf7ac.jpg",
    thickness: "1/2\"",
    width: "5\"",
    length: "Random Length",
    warranty: "Limited Lifetime",
    features: ["Bold Character", "Deep Grain Texture", "Handscraped Detail", "Premium Quality", "Long Lasting"],
    description: "Pulse pumps energy into spaces with bold grain patterns and deep character marks that celebrate natural wood beauty.",
    price: "Contact for pricing"
  },
  {
    id: 68,
    name: "Groove",
    sku: "ONN5896",
    collection: "Beat",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/beat-onn5896-groove-swatche73b.jpg",
    thickness: "1/2\"",
    width: "5\"",
    length: "Random Length",
    warranty: "Limited Lifetime",
    features: ["Distinctive Grain", "Mid-Tone Finish", "Engineered Durability", "Natural Look", "Easy Maintenance"],
    description: "Groove moves with natural wood rhythm, featuring distinctive grain patterns and mid-tone warmth perfect for contemporary homes.",
    price: "Contact for pricing"
  },

  // Onn:Core Collection - Waterproof Premium Flooring (8 products)
  {
    id: 69,
    name: "Essence",
    sku: "ONN5892",
    collection: "Core",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/core-onn5892-essence-swatch7c16.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Rigid Core Technology", "20mil Wear Layer", "100% Waterproof", "Sound Dampening", "Click Lock System"],
    description: "Essence captures the fundamental beauty of natural wood with rigid core stability and unmatched waterproof protection.",
    price: "Contact for pricing"
  },
  {
    id: 70,
    name: "Foundation",
    sku: "ONN5893",
    collection: "Core",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/core-onn5893-foundation-swatch78df.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Strong Rigid Core", "Pet & Child Safe", "Scratch Resistant", "Easy Installation", "Low Maintenance"],
    description: "Foundation provides solid, dependable performance with robust construction that stands strong under daily family life.",
    price: "Contact for pricing"
  },
  {
    id: 71,
    name: "Steadfast",
    sku: "ONN5895",
    collection: "Core",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/core-onn5895-steadfast-swatch6e56.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Unwavering Durability", "Waterproof Core", "Heavy Traffic Rated", "Fade Resistant", "Lifetime Warranty"],
    description: "Steadfast remains loyal to beauty and performance, delivering unwavering quality that never compromises on style or strength.",
    price: "Contact for pricing"
  },
  {
    id: 72,
    name: "Anchor",
    sku: "ONN5897",
    collection: "Core",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/core-onn5897-anchor-swatch8e23.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Stable Foundation", "Rigid Core Tech", "Moisture Proof", "Dent Resistant", "Commercial Grade"],
    description: "Anchor holds your space secure with exceptional dimensional stability and rich wood aesthetics that ground any design.",
    price: "Contact for pricing"
  },
  {
    id: 73,
    name: "Bedrock",
    sku: "ONN5898",
    collection: "Core",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/core-onn5898-bedrock-swatch4c19.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Ultimate Stability", "Waterproof Protection", "20mil Heavy Duty", "Thermal Resistance", "Above/Below Grade"],
    description: "Bedrock delivers rock-solid performance with unyielding durability and timeless beauty that forms the perfect flooring foundation.",
    price: "Contact for pricing"
  },
  {
    id: 74,
    name: "Enchant",
    sku: "ONN5899",
    collection: "Core",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/core-onn5899-enchant-swatchc077.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Captivating Design", "Rigid Core Strength", "Pet Friendly", "Easy Cleaning", "Enhanced Texture"],
    description: "Enchant mesmerizes with captivating wood grain patterns and premium rigid core technology that brings magic to every space.",
    price: "Contact for pricing"
  },
  {
    id: 75,
    name: "Pillar",
    sku: "ONN5900",
    collection: "Core",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/core-onn5900-pillar-swatch9aa1.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Strong Support", "Waterproof Design", "Commercial Durability", "Sound Reduction", "Easy Install"],
    description: "Pillar stands as a testament to strength and beauty, supporting your design vision with unwavering quality and elegant style.",
    price: "Contact for pricing"
  },
  {
    id: 76,
    name: "Stronghold",
    sku: "ONN5901",
    collection: "Core",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/core-onn5901-stronghold-swatchd73a.jpg",
    thickness: "6mm",
    width: "7\"",
    length: "48\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 15 Years Commercial",
    features: ["Maximum Strength", "Rigid Core", "100% Waterproof", "Lifetime Protection", "Heavy Traffic Proof"],
    description: "Stronghold defends against wear and moisture with maximum protection and bold wood character for spaces that demand the best.",
    price: "Contact for pricing"
  },

  // Onn:Pulse Collection - Engineered Hardwood (3 products)
  {
    id: 77,
    name: "Vitality",
    sku: "ONN5883",
    collection: "Pulse",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/pulse-vitality-ONN5883-swatch78e1.jpg",
    thickness: "1/2\"",
    width: "5\"",
    length: "Random Length",
    warranty: "Limited Lifetime",
    features: ["Premium Oak", "Wire Brushed", "Natural Character", "UV Oil Finish", "Dimensional Stability"],
    description: "Vitality infuses spaces with energy through dynamic premium oak character and rich, natural variations that bring warmth to life.",
    price: "Contact for pricing"
  },
  {
    id: 78,
    name: "Energy",
    sku: "ONN5884",
    collection: "Pulse",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/pulse-energy-ONN5884-swatchbda4.jpg",
    thickness: "1/2\"",
    width: "5\"",
    length: "Random Length",
    warranty: "Limited Lifetime",
    features: ["Bold Grain Patterns", "Handscraped Texture", "Engineered Construction", "Easy Maintenance", "Long Lasting Beauty"],
    description: "Energy radiates with bold, dynamic wood grain and handcrafted details that invigorate interiors with authentic character.",
    price: "Contact for pricing"
  },
  {
    id: 79,
    name: "Verve",
    sku: "ONN5885",
    collection: "Pulse",
    type: "hardwood",
    category: "Engineered Hardwood",
    image: "https://www.onnsurfacepremiumflooring.com/cdn/shop/files/pulse-verve-ONN5885-swatchf7ac.jpg",
    thickness: "1/2\"",
    width: "5\"",
    length: "Random Length",
    warranty: "Limited Lifetime",
    features: ["Spirited Design", "Natural Variations", "Premium Oak", "Durable Finish", "Timeless Appeal"],
    description: "Verve brings spirited enthusiasm to floors with lively oak patterns and premium craftsmanship that never goes out of style.",
    price: "Contact for pricing"
  },

  // ProMaster Floors - Norton Collection LVP (3 products)
  {
    id: 80,
    name: "ProSeries BLAZE",
    sku: "PM-PROSERIES-BLAZE",
    collection: "ProSeries",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://cdn.shopify.com/s/files/1/0533/3123/0873/files/norton-blaze-swatch.jpg",
    thickness: "7-7/8mm",
    width: "7-7/8\"",
    length: "29-1/2\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 10 Years Commercial",
    features: ["SPC Core", "Waterproof", "Pet Friendly", "Easy Click Lock", "Commercial Grade"],
    description: "ProSeries BLAZE ignites spaces with warm, fiery tones and rugged durability designed for high-performance residential and commercial applications.",
    price: "Contact for pricing"
  },
  {
    id: 81,
    name: "ProSeries NEON",
    sku: "PM-PROSERIES-NEON",
    collection: "ProSeries",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://cdn.shopify.com/s/files/1/0533/3123/0873/files/norton-neon-swatch.jpg",
    thickness: "7-7/8mm",
    width: "7-7/8\"",
    length: "29-1/2\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 10 Years Commercial",
    features: ["Vibrant Design", "Waterproof Core", "Scratch Resistant", "Fast Installation", "Heavy Duty"],
    description: "ProSeries NEON shines bright with contemporary styling and exceptional wear resistance perfect for modern, active living spaces.",
    price: "Contact for pricing"
  },
  {
    id: 82,
    name: "ProSeries RED HEAT",
    sku: "PM-PROSERIES-REDHEAT",
    collection: "ProSeries",
    type: "vinyl",
    category: "Luxury Vinyl Plank",
    image: "https://cdn.shopify.com/s/files/1/0533/3123/0873/files/norton-redheat-swatch.jpg",
    thickness: "7-7/8mm",
    width: "7-7/8\"",
    length: "29-1/2\"",
    wearLayer: "20mil",
    warranty: "Lifetime Residential / 10 Years Commercial",
    features: ["Rich Red Tones", "SPC Construction", "100% Waterproof", "Pet & Kid Proof", "Lifetime Warranty"],
    description: "ProSeries RED HEAT delivers intense character with rich, warm red undertones and commercial-grade performance for demanding environments.",
    price: "Contact for pricing"
  }
];

export const collections = [
  {
    name: "ComfortSense",
    description: "Water-Resistant Laminate flooring with realistic wood appearance",
    type: "laminate"
  },
  {
    name: "SolidSense",
    description: "Rigid-Core Vinyl (SPC) flooring for enduring beauty",
    type: "vinyl"
  },
  {
    name: "NatureSense",
    description: "Premium Engineered Hardwood with authentic natural beauty",
    type: "hardwood"
  },
  {
    name: "Accessories",
    description: "Complete your installation with our quality accessories",
    type: "accessories"
  }
];

export const filterOptions = {
  types: [
    { value: "all", label: "All Products" },
    { value: "laminate", label: "Water-Resistant Laminate" },
    { value: "hardwood", label: "Engineered Hardwood" }
  ],
  collections: [
    { value: "all", label: "All Collections" },
    { value: "ComfortSense", label: "ComfortSense" },
    { value: "NatureSense", label: "NatureSense" },
    { value: "Guard", label: "Guard" },
    { value: "Beat", label: "Beat" },
    { value: "Pulse", label: "Pulse" }
  ],
  accessories: []
};
